import React from "react";
import { AdBanner, AD_SLOT_TYPE__BOTTOM } from '@insiderintelligence/googleadmanager';
import styled from "styled-components";


const OuterContainer = styled.div`
  iframe {
    margin: 0 auto;
  }
`;

export const BottomAd = (): JSX.Element => {
  return (
    <OuterContainer className="w-auto min-h-bottom-banner md:min-h-bottom-banner-medium lg:min-h-bottom-banner-desktop lg:mb-11 -mt-5 mb-7">
      <AdBanner adSlotType={AD_SLOT_TYPE__BOTTOM} />
    </OuterContainer>
  );
};